export default {
   email: "verleih@sjr-fuerth.de"
};